import { useEffect, useState } from "react"
import Tag from "../../../fragments/Tag"

const AttorneysTags = ({data, outOfState}) => {
    const [tags, setTags] = useState(null)
    const [outOfStateTag, setOutOfStateTag] = useState(null)
    useEffect(() => {
        let arr = []
        for (const [key, value] of Object.entries(data)) {
            
            if (key !== 'no_major_med' && key !== 'no_med_pay') {
                if (value !== 0) {
                    arr.push({
                        label: key.split('_').join(' '),
                        active: value
                    })
                }
            }
        }
        
        setTags(arr)


    }, [data])

    useEffect(() => {
        if (outOfState) {
            if (outOfState.out_of_state) {
                setOutOfStateTag(true)
            } else {
                setOutOfStateTag(false)
            }
        }
    }, [outOfState])

    return <>
        {tags && tags.map(item => (
            <Tag key={item.label}>{item.label}</Tag>
        ))}

        {outOfStateTag && <Tag>Out Of State</Tag>}
    </>
}

export default AttorneysTags